import axios from 'axios';


const authenticatedAxios = axios.create({
  withCredentials: true,
  xsrfCookieName: null,
  xsrfHeaderName: null,
  baseURL: '//dgs.wixapps.net/bizmanager',
});

export default authenticatedAxios;



// WEBPACK FOOTER //
// ./src/api/business-manager-settings/business-manager-settings.js